import React, { useState } from 'react';
import { Form, Input, Button, notification, Icon } from 'antd';

import { recoverApi } from '../../api/user';

import './ForgotForm.scss';

export default function ForgotForm() {
	const [inputs, setInputs] = useState({ email: '' });
	const [isLoading, setIsLoading] = useState(false);

	const changeForm = (e) => {
		setInputs({
			...inputs,
			[e.target.name]: e.target.value,
		});
	};

	const recover = async (e) => {
		e.preventDefault();
		setIsLoading(true);
		if (!inputs.email) {
			notification['error']({
				message: 'Debe ingresar Correo de recuperación de contraseña',
			});
			setIsLoading(false);
		} else {
			const result = await recoverApi(inputs);
			debugger;
			if (result.estado === 'Error') {
				notification['error']({
					message: result.result,
				});
				setIsLoading(false);
			} else {
				notification['success']({
					message:
						'Su solicitud se ha registrado satisfactoriamente, por favor continue el proceso con la información enviada a su correo electrónico',
				});
				setIsLoading(false);
				setInputs({ email: '' });
			}
		}
	};

	return (
		<Form className="forgot-form" onChange={changeForm} onSubmit={recover}>
			<Form.Item>
				<div className="forgot-form__info">
					Si no recuerda su contraseña, solo debe ingresar el correo electrónico con el que se encuentra
					registrado en el portal, y debe seguir las indicaciones que serán notificadas a este correo
				</div>
			</Form.Item>
			<Form.Item>
				<Input
					prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />}
					type="email"
					name="email"
					placeholder="Correo Electrónico"
					className="login-form__input"
					/*onChange={inputValidation}*/
					value={inputs.email}
				/>
			</Form.Item>

			<Form.Item>
				<Button htmlType="submit" className="forgot-form__button" loading={isLoading}>
					Recuperar contraseña
				</Button>
			</Form.Item>
		</Form>
	);
}
